/**
 * Card section component
 * 
 */

import React, { PureComponent } from 'react';

// Components

import Image from '../image/image';
import Ul from '../ul/ul';

export default class CardSection extends PureComponent {

	render() {
		
		const { title, text, label, items, image } = this.props.data;
		const classes = this.props.count % 2 ? 'card card-section' : 'card card-section card-reverse';
		
		return (

			<div className={classes}>
				<div className="card-details">

					{ !! title && <h3>{title}</h3> }
					{ !! text && <p>{text}</p> }
					{ !! label && <h6>{label}</h6> }
					
					<Ul items={items} classes="list list-cap"></Ul>

				</div>
				<figure className="card-image"><Image data={image} classes="cover lazyloaded"/></figure>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/cards/card-section.js